import * as _ from "lodash"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_CustomerTypeRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Customer_Type} from "../PA.Core/PAdbSchema";
import {CustomerTypeBO} from "./CustomerTypeBO";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class CustomerTypeBOValidations {

    static async ValidateFields(aBO: CustomerTypeBO): Promise<void> {
        const self = this;
        let dbContext = new PAdbContext({})
        let userContext = PAEnvironment.getValue(PAEnvironment.UserContext, 'UserContext')
        let bHasRole = userContext.hasRoleId("Customer_Data_Editor")

        if (_.isEmpty(aBO.WB_CustomerType.cif.CUSTM_ID) && _.isEmpty(aBO.WB_CustomerType.cif.CUSTM_NAME) && !bHasRole){
            self.addMessage(aBO, "viewerRoleCreate", 'Only Users with Editor Role can Create a new Customer Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleCreate")
        }

        if(!bHasRole){
            self.addMessage(aBO, "viewerRoleSave", 'Only Users with Editor Role can update a Customer Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleSave")
        }

        if (_.isEmpty(aBO.WB_CustomerType.cif.CUSTM_ID))
        {
            self.addMessage(aBO, "emptyID", 'Customer ID cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyID")
        if (_.isEmpty(aBO.WB_CustomerType.cif.CUSTM_NAME))
        {
            self.addMessage(aBO, "emptyName", 'Customer Name cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyName")


        // Customer Types are considered duplicates only within the same Master Data Set
        let customerTypeRows: WB_CustomerTypeRow[] = await dbContext.findAll(esWB_Customer_Type,
            {where: {DELETED_IND: {neq: '1'},
                            WB_CUSTM_ID: {neq: aBO.WB_CustomerType.cif.WB_CUSTM_ID},
                            WB_MDSET_ID: aBO.WB_CustomerType.cif.WB_MDSET_ID,
                            CUSTM_ID: aBO.WB_CustomerType.cif.CUSTM_ID}})


        if (!_.isEmpty(customerTypeRows)) {
            self.addMessage(aBO, "duplicateID", 'Existing Customer Type(s) with the same ID: ' +
                '\nCustomer Types: ' + _.map(customerTypeRows, (a) => a.cif.CUSTM_NAME).join(", ")
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }


    }

    private static addMessage(aBO: CustomerTypeBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}